import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, BookOpen } from "lucide-react";
import { api } from "../lib/api";
import SectionHeading from "./SectionHeading";

export default function ArticlesTeaser() {
  const [articles, setArticles] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api("/articles")
      .then((d) => setArticles(d.slice(0, 3)))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  if (loaded && articles.length === 0) return null;

  return (
    <section className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <SectionHeading
          eyebrow="The Journal"
          title="Evidence-Based Nutrition Guides"
          sub="No fads, no clickbait — practical dietetics written for busy people."
        />
        <div className="mt-12 grid md:grid-cols-3 gap-6 items-stretch">
          {articles.map((a, i) => (
            <motion.div
              key={a.id}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="group flex flex-col rounded-3xl border border-line bg-panel p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-accent/50 hover:shadow-glow-emerald"
              data-testid={`article-teaser-${i}`}
            >
              <span className="px-3 py-1 rounded-full bg-gold/10 border border-gold/30 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-gold self-start">
                {a.category}
              </span>
              <h3 className="mt-5 font-display text-xl font-extrabold uppercase text-white leading-snug">
                {a.title}
              </h3>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed flex-1 line-clamp-3">{a.excerpt}</p>
              <Link
                to={`/blog/${a.slug}`}
                data-testid={`article-teaser-link-${i}`}
                className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-emerald-400 transition-colors hover:text-emerald-300"
              >
                Read Article <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </motion.div>
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link
            to="/blog"
            data-testid="article-teaser-view-all"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-accent/50 text-emerald-300 font-bold uppercase tracking-wide text-sm transition-all duration-300 hover:bg-accent hover:text-ink"
          >
            <BookOpen className="h-4 w-4" /> Browse All Articles
          </Link>
        </div>
      </div>
    </section>
  );
}